"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAENavbarItemsSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _Notifications = _interopRequireDefault(require("@material-ui/icons/Notifications"));

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _FAENavbarItems = require("../FAENavbarItems/FAENavbarItems");

var _FAEDropdown = require("../FAEDropdown/FAEDropdown");

var _FAEText = require("../FAEText/FAEText");

require("./FAENavbarItemsSection.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// libs
// src
// scss
const FAENavbarItemsSection = _ref => {
  let {
    isLogin,
    dropDownInfo = {},
    itemsList,
    userName = "Guest",
    ordersClicked,
    userNameClicked,
    notificationsList = [],
    expertLogoClicked,
    expertLogo,
    userCountry,
    mobileMenu
  } = _ref;
  const {
    list,
    userStatus,
    label,
    icon,
    userStatusSignedInLabel,
    userStatusSignedOutLabel,
    userStatusSignedInIcon,
    userStatusSignedOutIcon,
    signInClicked,
    signOutClicked
  } = dropDownInfo;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-section-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: userNameClicked,
    className: "fae--navbar-items-section-greeting"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    primary: true
  }, "Hello ", userName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-section-items-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-section-items"
  }, /*#__PURE__*/_react.default.createElement(_FAENavbarItems.FAENavbarItems, {
    itemsList: itemsList
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-section-dropdown-items"
  }, /*#__PURE__*/_react.default.createElement(_FAEDropdown.FAEDropdown, {
    primary: true,
    isLogin: isLogin,
    list: list,
    label: label,
    userStatus: userStatus,
    icon: icon,
    userStatusSignedInIcon: userStatusSignedInIcon,
    userStatusSignedInLabel: userStatusSignedInLabel,
    userStatusSignedOutIcon: userStatusSignedOutIcon,
    userStatusSignedOutLabel: userStatusSignedOutLabel,
    signInClicked: signInClicked,
    signOutClicked: signOutClicked
  }), isLogin && /*#__PURE__*/_react.default.createElement(_FAEDropdown.FAEDropdown, {
    primary: true,
    list: notificationsList,
    icon: /*#__PURE__*/_react.default.createElement(_Notifications.default, {
      style: {
        fontSize: "20px"
      }
    })
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "fae--navbar-items-divider"
  }), /*#__PURE__*/_react.default.createElement("p", {
    onClick: ordersClicked,
    className: "fae--navbar-items-section-dropdown-items-item"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    primary: true
  }, "Orders")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--nav-bar-items-for-mobile-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-for-mobile-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-logo-for-mobile-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      cursor: "pointer"
    },
    onClick: expertLogoClicked,
    src: expertLogo,
    alt: "Expert",
    width: "100px",
    height: "auto"
  }), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    bold: true,
    style: {
      fontSize: "9px"
    },
    paragraph: true,
    primary: true
  }, userCountry)), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--mobile-nav-bar-actions-wrapper"
  }, isLogin && /*#__PURE__*/_react.default.createElement(_FAEDropdown.FAEDropdown, {
    primary: true,
    list: notificationsList,
    icon: /*#__PURE__*/_react.default.createElement(_Notifications.default, {
      style: {
        fontSize: "20px",
        color: "white"
      }
    })
  }), /*#__PURE__*/_react.default.createElement(_FAEDropdown.FAEDropdown, {
    primary: true,
    list: mobileMenu,
    icon: /*#__PURE__*/_react.default.createElement(_Menu.default, {
      style: {
        fontSize: "20px",
        color: "white"
      }
    })
  })))));
};

exports.FAENavbarItemsSection = FAENavbarItemsSection;